/**
 * Vessel-scoped meta keys helper
 * Ensures all meta settings are properly isolated by vessel
 */
export const metaKey = (base, vesselId) => `${base}:${vesselId}`;

/**
 * Common meta key patterns for consistency
 */
export const META_KEYS = {
  // UI preferences
  paperMode: (vesselId) => metaKey('familiarisationPaperMode', vesselId),
  sidebarCollapsed: (vesselId) => metaKey('sidebarCollapsed', vesselId),
  dashboardLayout: (vesselId) => metaKey('dashboardLayout', vesselId),
  
  // Module settings
  drillSettings: (vesselId) => metaKey('drillSettings', vesselId),
  maintenanceSettings: (vesselId) => metaKey('maintenanceSettings', vesselId),
  defectSettings: (vesselId) => metaKey('defectSettings', vesselId),
  
  // Custom items
  customFamiliarisation: (vesselId) => metaKey('customFamiliarisationItems', vesselId),
  customEquipment: (vesselId) => metaKey('customEquipment', vesselId),
  customDrills: (vesselId) => metaKey('customDrills', vesselId),
  
  // Job descriptions
  customJobDesc: (jobId, vesselId) => metaKey(`custom_job_desc:${jobId}`, vesselId),
  
  // Photos and media
  crewPhoto: (crewId, vesselId) => metaKey(`crew_photo:${crewId}`, vesselId),
  vesselPhoto: (vesselId) => metaKey('vessel_photo', vesselId),
  
  // Temporary/cache data
  importProgress: (vesselId) => metaKey('importProgress', vesselId),
  syncStatus: (vesselId) => metaKey('syncStatus', vesselId)
};